import moment from 'moment'
import NumAbbr from 'number-abbreviate'
import Slugify from 'slugify'

export const helpers = {
  directives: {
    'external-click': {
      bind (el, binding, vnode) {
        el['@external-click'] = function (event) {
          if (
            !el.contains(event.target) &&
            binding.expression &&
            vnode.context[binding.expression]
            ) {
            binding.value()
          }
        }
        document.addEventListener('click', el['@external-click'], true)
      },
      unbind (el) {
        document.removeEventListener('click', el['@external-click'], true)
      }
    }
  },
  methods: {
    abbreviateNumber (x, decPlaces) {
      // decPlaces 0, 1, or 2
      let numAbbr = new NumAbbr()
      return numAbbr.abbreviate(x, decPlaces)
    },
    capitalizeFirstLetter (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    dateFormat (date, format) {
      return moment(date).format(format)
    },
    headerDate (date) {
      date = moment(date)

      // No header if older than 6 days
      if (date.isBefore(moment().startOf('day').subtract(6, 'days'))) {
        return null
      }

      return date.calendar(null, {
        sameDay: '[Today]',
        lastDay: '[Yesterday]',
        lastWeek: 'dddd'
      })
    },
    isNumeric (x) {
      return !isNaN(parseFloat(x)) && isFinite(x)
    },
    number (x) {
      x = x || 0
      if (!isFinite(x) || isNaN(x)) x = 0
      return Number(x)
    },
    numberWithCommas (x) {
      x = this.number(x)
      return x.toLocaleString()
    },
    numberDifference (a, b) {
      let percentage = this.sanitize(((a - b) / b) * 100)
      let fixed = percentage.toFixed(2)

      return {
        'amount': this.number(a - b),
        'difference': this.number(fixed),
        'direction': fixed > 0 ? '+' : ''
      }
    },
    resizedImage (url, width, height) {
      // @TODO: Make this work for more than just shopify
      return url.replace('600x600.', `${width}x${height}.`)
    },
    sanitize (x) {
      if (!this.isNumeric(x)) {
        return 0
      }

      return x
    },
    slugify (str) {
      return Slugify(str, {
        replacement: '-',
        remove: /[$*_+~.()'"!\-:@]/g,
        lower: true
      })
    },
    timeFromNow (date) {
      return moment(date).fromNow()
    },
    triggerWindowResize () {
      if (typeof (Event) === 'function') { // Modern browsers
        window.dispatchEvent(new Event('resize'))
      } else { // IE and old browsers
        let evt = window.document.createEvent('UIEvents')
        evt.initUIEvent('resize', true, false, window, 0)
        window.dispatchEvent(evt)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/mixins/helpers.js